import Header from "@/components/showcase/Header";
import Slideshow from "@/components/showcase/Slideshow";
import Marquee from "@/components/showcase/Marquee";
import Services from "@/components/showcase/Services";
import Formations from "@/components/showcase/Formations";
import Pricing from "@/components/showcase/Pricing";
import Faq from "@/components/showcase/Faq";
import Boussole from "@/components/showcase/Boussole";
import Gallery from "@/components/showcase/Gallery";
import About from "@/components/showcase/About";
import Contact from "@/components/showcase/Contact";
import Partners from "@/components/showcase/Partners";
import Announcements from "@/components/showcase/Announcements";
import Footer from "@/components/showcase/Footer";
import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function Landing() {
  const [content, setContent] = useState(null);
  useEffect(() => {
    api
      .get("/public/content")
      .then((r) => setContent(r.data))
      .catch(() => setContent({}));
  }, []);
  return (
    <div className="grain min-h-screen bg-korban-navy">
      <Header />
      <main>
        <Slideshow imgOverrides={content?.photos || {}} textOverrides={content?.texts || {}} />
        <Marquee />
        <Announcements announcements={content?.announcements || []} />
        <Services />
        <Formations formations={content?.formations} />
        <Pricing />
        <Faq />
        <Boussole />
        <Gallery items={content?.gallery} />
        <About aboutImg={content?.photos?.apropos} />
        <Contact />
        <Partners partners={content?.partners} />
      </main>
      <Footer />
    </div>
  );
}
